/*
 *+------------------------------------------------------------------------+
 *| Licensed Materials - Property of IBM
 *| IBM Cognos Products: BI Dashboard
 *| (C) Copyright IBM Corp. 2016, 2017
 *|
 *| US Government Users Restricted Rights - Use, duplication or disclosure
 *| restricted by GSA ADP Schedule Contract with IBM Corp.
 *+------------------------------------------------------------------------+
 */
define([], function(){


	/**
	 *we could pass options for initialization
	 *@constructor
	 */
	var ColorUtils = function(){
		return {
			/**
			 * Invert the given color by inverting the brightness of the color
			 * @param color, the base color
			 * @param factor (default: 180), amount of brightness to change
			 * @param threshold (default: 100), threshold between bright and dark
			 * @param [ignoreMinContrast=false] use carfully since can cause a11y issues.
			 */
			invertColor: function(color, factor = 180, threshold = 100, ignoreMinContrast = false) {
				var yuv = this._convertRGBToYUV(color);
				// Simply adjust the brightness
				yuv.y = this._validateColor(yuv.y + (yuv.y > threshold ? -factor : factor));
				var invertedColor = this._convertYUVToRGB(yuv);
				if (ignoreMinContrast) {
					return invertedColor;
				}
				// Expect the contrast ratio to be 4.5 : 1 or higher
				// https://www.w3.org/TR/WCAG20/#visual-audio-contrast-contrast
				if (this.contrastRatio(color, invertedColor) < 4.5) {
					// Use black or white for lower contrast colors
					if (this.contrastRatio(color, '#FFFFFF') < 4.5) {
						return '#000000';
					}
					return '#FFFFFF';
				}
				return invertedColor;
			},
			_convertRGBToYUV: function(color) {
				// ignore the prepended #
				var r = parseInt(color.substring(1,3), 16);
				var g = parseInt(color.substring(3,5), 16);
				var b = parseInt(color.substring(5), 16);
				return {
					y: this._validateColor(r *  0.29900 + g *  0.587   + b * 0.114),
					u: this._validateColor(r * -0.16874 + g * -0.33126 + b * 0.50000 + 128),
					v: this._validateColor(r *  0.50000 + g * -0.41869 + b * -0.08131 + 128)
				};
			},
			_convertYUVToRGB: function(yuv) {
				var r = this._validateColor(yuv.y + (yuv.v - 128) *  1.40200);
				var g = this._validateColor(yuv.y + (yuv.u - 128) * -0.34414 + (yuv.v - 128) * -0.71414);
				var b = this._validateColor(yuv.y + (yuv.u - 128) *  1.77200);

				return '#' +
					(r < 16 ? '0' + r.toString(16) : r.toString(16)) +
					(g < 16 ? '0' + g.toString(16) : g.toString(16)) +
					(b < 16 ? '0' + b.toString(16) : b.toString(16));
			},
			_validateColor: function(n) {
				return n < 0 ? 0 : (n > 255 ? 255 :  Math.floor(n));
			},

			/**
			 * Calculate the relative luminance of a RGB color
			 * see https://www.w3.org/TR/WCAG20/#relativeluminancedef
			 */
			luminance: function (color) {
				// ignore the prepended #
				var r = parseInt(color.substring(1,3), 16);
				var g = parseInt(color.substring(3,5), 16);
				var b = parseInt(color.substring(5), 16);

				r /= 255;
				g /= 255;
				b /= 255;

				r = (r <= 0.03928) ? r / 12.92 : Math.pow((r + 0.055) / 1.055, 2.4);
				g = (g <= 0.03928) ? g / 12.92 : Math.pow((g + 0.055) / 1.055, 2.4);
				b = (b <= 0.03928) ? b / 12.92 : Math.pow((b + 0.055) / 1.055, 2.4);

				// For the sRGB colorspace, the relative luminance of a color is defined as:
				return 0.2126 * r + 0.7152 * g + 0.0722 * b;
			},

			/**
			 * Calculate the contrast ratio between two colors
			 * see https://www.w3.org/TR/WCAG20/#contrast-ratiodef
			 */
			contrastRatio: function(color1, color2) {
				var l1 = this.luminance(color1);
				var l2 = this.luminance(color2);

				return (l1 > l2) ? (l1 + 0.05) / (l2 + 0.05) : (l2 + 0.05) / (l1 + 0.05);
			}
		};
	};

	return new ColorUtils();
});
